import Axios, { AxiosResponse } from "axios";
import { IApplicationInfo } from "../models/dto/application.dto";
import { EApplicationType, ISaveApplicationRequestDTO } from "../models/dto/save-application-request.dto";
import { KuikaAppManager } from "../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../shared/utilty/main-functions";

const backendUrl = KuikaAppManager.GetBackendUrl();
const projectId = "9eb4eded-151b-45b3-e7cd-08dcd67276a2";
const projectName = "GiftCard";

export class ApplicationService {
  public static async saveApplication() {
    const virtualDirectoryURL: string = "auto"; // Use by code generation
    return Axios.post<ISaveApplicationRequestDTO, AxiosResponse<any>>(`${backendUrl}/application`, {
      projectId,
      applicationType: EApplicationType.Frontend,
      applicationName: projectName,
      baseUrl: KMainFunctions.windowLocationOrigin,
      description: `${projectName} application frontend`
    });
  }

  public static async getAllApplications(): Promise<AxiosResponse<IApplicationInfo[]>> {
    return Axios.get<IApplicationInfo[]>(`${backendUrl}/application/all`);
  }

  public static injectPreConnectLinks = () => {
    const APPS_TO_BE_PRECONNECTED: string[] = [];

    if (APPS_TO_BE_PRECONNECTED.length === 0) {
      return;
    }

    const applications = this.getAllApplicationsFromSessionStorage()?.frontEndApplications || [];

    if (applications.length === 0) {
      return;
    }

    const head: HTMLHeadElement = document.getElementsByTagName("head")[0];
    const preconnectLinks: NodeListOf<HTMLLinkElement> = head.querySelectorAll("link[rel='preconnect']");
    const preconnectLinksHref = Array.from(preconnectLinks).map((link) => link.href);

    applications.forEach((app) => {
      if (APPS_TO_BE_PRECONNECTED.includes(app.baseUrl) && !preconnectLinksHref.includes(app.baseUrl)) {
        const link = document.createElement("link");
        link.rel = "preconnect";
        link.href = app.baseUrl;
        head.appendChild(link);
      }
    });
  };

  public static saveAllApplicationsToSessionStorage = async () => {
    if (sessionStorage.getItem("all-applications") && sessionStorage.getItem("front-end-applications")) {
      return;
    }

    const response = await ApplicationService.getAllApplications();

    if (response.status !== 200) return;

    sessionStorage.setItem("all-applications", JSON.stringify(response.data));
    sessionStorage.setItem(
      "front-end-applications",
      JSON.stringify(response.data.filter((app) => app.applicationType === EApplicationType.Frontend))
    );
  };

  public static getAllApplicationsFromSessionStorageRaw = (): {
    allApplications: string;
    frontEndApplications: string;
  } | null => {
    const allApplications = sessionStorage.getItem("all-applications");
    const frontEndApplications = sessionStorage.getItem("front-end-applications");
    if (!allApplications || !frontEndApplications) {
      return null;
    }
    return {
      allApplications,
      frontEndApplications
    };
  };

  public static getAllApplicationsFromSessionStorage = (): {
    allApplications: IApplicationInfo[];
    frontEndApplications: IApplicationInfo[];
  } | null => {
    const applications = ApplicationService.getAllApplicationsFromSessionStorageRaw();

    if (!applications) return null;

    return {
      allApplications: JSON.parse(applications.allApplications),
      frontEndApplications: JSON.parse(applications.frontEndApplications)
    };
  };
}
